var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"informationSet"},[_c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"短信长链绑定","name":"first"}},[(_vm.longUrlBindShow)?_c('longUrlBind'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }